export var BannerNotificationStatusType;
(function (BannerNotificationStatusType) {
    BannerNotificationStatusType["ENABLE"] = "enabled";
    BannerNotificationStatusType["DISABLE"] = "disabled";
    BannerNotificationStatusType["EXPIRED"] = "expired";
})(BannerNotificationStatusType || (BannerNotificationStatusType = {}));
//# sourceMappingURL=BannerNotificationStatusType.js.map